<template>
	<div class="cmo">
        <div class="cmo_content">
            <!-- 左右布局 -->
            <div class="product-detail-container">
                <!-- 左侧：药品图片 -->
                <div v-if="materialDetail?.productPicture" class="product-image">
					<div class="img_container">
                        <el-image
                            :src="materialDetail?.productPicture"
                            :alt="materialDetail?.chineseName || '产品图片'"
                            :preview-src-list="previewImageList"
                            show-progress
                            fit="cover"
                            lazy
                            class="product-image-element"
                        />
                    </div>
                </div>

                <!-- 右侧：药品信息 -->
                <div class="product-info">
                    <h2>{{ materialDetail?.chineseName || '暂无'}}</h2>
                    <ul class="info-list">
                        <li><strong>中文名称：</strong>{{ materialDetail?.chineseName || '暂无' }}</li>
                        <li><strong>英文名称：</strong>{{ materialDetail?.englishName || '暂无' }}</li>
                        <li><strong>CAS 号：</strong>{{ materialDetail?.casNumber || '暂无' }}</li>
                        <li><strong>质量标准：</strong>{{ materialDetail?.qualityStandard || '暂无'}}</li>
                        <li><strong>产品状态：</strong>{{ materialDetail?.productStatus || '暂无' }}</li>
                        <li><strong>产品性状：</strong>{{ materialDetail?.productCharacteristics || '暂无' }}</li>
                    </ul>
                    <!-- 下载按钮 -->
					<el-button v-if="materialDetail?.sdsDownload" color="#0055A2" type="primary" plain @click="sdsDownloadMethod()">SDS下载</el-button>
                </div>
            </div>
        </div>
	</div>
</template>

<script setup lang="ts">
	import { ref, computed } from 'vue'
	import { useConfigStore } from "@/stores/index.ts";
	const store = useConfigStore()
	
	// 从store获取新闻详情
	const materialDetail = computed(() => {
		console.log(store.getMaterialDetail(),"store.getMaterialDetail()");
		return store.getMaterialDetail()
	})

    // 预览图片列表
    const previewImageList = computed(() => {
        return [materialDetail.value?.productPicture]
    })

	// 获取配置信息
	const configData = computed(() => {
		console.log(store.configData,"store.configData")
		return store.configData
	})

	const sdsDownloadMethod = () => {
		console.log(materialDetail.value?.sdsDownload, "下载地址")
		window.open(materialDetail.value?.sdsDownload)
	}
</script>

<style lang="styl" scoped>
.cmo {
	width 100%
	min-height calc(100% - 70px - 220px)
	background-color #fff
	min-width 1200px
	padding-bottom 100px
	.carousel{
		margin-bottom 180px
	}
	.cmo_content {
		width 100%
		height 100%
		padding 20px 200px 100px 200px
		display flex
		justify-content center
		align-items flex-start
		gap 60px
		@media (max-width: 1400px) {
			padding: 20px 100px 100px 100px;
		}
	}

	.product-detail-container {
		display flex
		width 100%
		max-width 1200px
		gap 60px
	}

	.product-image {
		flex 1
		.img_container{
			margin-bottom 20px
			position: relative
			height: 0
			width 437px
			padding-bottom: 66.67%
			background-color: #fff; // 添加白色背景到容器
			.el-image {
				position: absolute
				top: 0
				left: 0
				width: 100%
				height: 100%
				object-fit: cover
			}
			
			// 为图片元素添加白色背景
			:deep(.el-image__inner) {
				background-color: #fff;
			}
		}
	}

	.product-info {
		flex 2
		font-size 14px
		color #333
		line-height 1.6
		padding 10px 0
		h2 {
			font-size 20px
			font-weight bold
			color #333
			margin-bottom 6px
		}

		.info-list {
			list-style none
			margin 0
			padding 0 0 5px 0
			li {
				margin-bottom 6px
			}
		}
	}
}

// 为预览图片添加白色背景
:deep(.el-image-viewer__img) {
	background-color: #fff !important;
}
</style>